module.exports = __webpack_public_path__ + "img/icon-solid-check.104aec78.svg";